
<select
  :id="initialPlacement ? 'to-be-footer-lang-select' : 'footer-lang-select'"
  name="language"
  class="footer__select ws-vue-lang-select-hijack"
  :class="{ hidden: initialPlacement }"
  @change="setLanguage"
>
  <option
    v-for="lang in langs"
    :key="lang[0]"
    :selected="selectedLang === lang[0]"
    :value="lang[0]"
  >
    {{ lang[1] }}
  </option>
</select>
